import { hFetch } from '@/lib/hfetch';
import type { PipelineReviewQuestionEntity } from '@/api/entity_types/pipeline_review/Question';

export const listQuestions = async () => {
  return await hFetch<PipelineReviewQuestionEntity[]>({
    url: '/api/pipeline_review/questions',
  });
};

export const createQuestion = async (params: Pick<PipelineReviewQuestionEntity, 'question'>) => {
  return await hFetch<PipelineReviewQuestionEntity, unknown>({
    url: '/api/pipeline_review/questions',
    method: 'POST',
    payload: { pipeline_review_question: params },
  });
};

export const updateQuestion = async (id: number, params: Partial<PipelineReviewQuestionEntity>) => {
  return await hFetch<PipelineReviewQuestionEntity, unknown>({
    url: `/api/pipeline_review/questions/${id}`,
    method: 'PUT',
    payload: { pipeline_review_question: params },
  });
};

export const deleteQuestion = async (id: number) => {
  return await hFetch({
    url: `/api/pipeline_review/questions/${id}`,
    method: 'DELETE',
  });
};
